import { useContext } from "react";
import { SignalRContext } from "../SignalRContext";
import { SignalRClientMethod, SignalRServerMethod } from "../constants";
import { SignalRFormSubmissionsContext } from "./SignalRFormSubmissionsContext";

interface IProps {
  children?: React.ReactNode;
}

const SignalRFormSubmissionsProvider = (props: IProps) => {
  const context = useContext(SignalRContext);

  return (
    <SignalRFormSubmissionsContext.Provider
      value={{
        sendUpdateFormSubmissions: (...args) => context.invoke(SignalRServerMethod.SendUpdateFormSubmissions, args),
        onShouldUpdateFormSubmissions: (handler) =>
          context.registerHandler(SignalRClientMethod.ShouldUpdateFormSubmissions, handler),
        offShouldUpdateFormSubmissions: (handler) =>
          context.unregisterHandler(SignalRClientMethod.ShouldUpdateFormSubmissions, handler),
        sendUpdateFormSubmissionDetail: (...args) =>
          context.invoke(SignalRServerMethod.SendUpdateFormSubmissionDetail, args),
        onShouldUpdateFormSubmissionDetail: (handler) =>
          context.registerHandler(SignalRClientMethod.ShouldUpdateFormSubmissionDetail, handler),
        offShouldUpdateFormSubmissionDetail: (handler) =>
          context.unregisterHandler(SignalRClientMethod.ShouldUpdateFormSubmissionDetail, handler),
      }}
    >
      {props.children}
    </SignalRFormSubmissionsContext.Provider>
  );
};

export { SignalRFormSubmissionsProvider };
